// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSource
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { Message } from "abweb/dto/Message";
import { AbstractClientRequestContext } from "abweb/dto/ds/AbstractClientRequestContext";
import { AbstractDataSource } from "abweb/dto/ds/AbstractDataSource";
import { DataSource } from "abweb/dto/ds/DataSource";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceBase extends AbstractDataSource {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSource";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSource(json.argumentValues != null ? json.argumentValues : null, TSOGUtils.decodeObject(json.clientRequestContext, AbstractClientRequestContext, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "clientRequestContext")), json.id != null ? json.id : null, json.dataSources != null ? TSOGUtils.decodeObjectArray(json.dataSources, DataSource, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dataSources")) : null, json.focusedNodeId != null ? json.focusedNodeId : null, json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, Message, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, TSOGUtils.decodeObject(json.rootNode, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "rootNode")), json.templateMap != null ? json.templateMap : null);
  }
  initGraphicalDataSource(argumentValues, clientRequestContext, id, dataSources, focusedNodeId, messages, rootNode, templateMap) {
    this.initAbstractDataSource(argumentValues, clientRequestContext, id);
    this._dataSources = dataSources;
    this._focusedNodeId = focusedNodeId;
    this._messages = messages;
    this._rootNode = rootNode;
    this._templateMap = templateMap;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._dataSources != null) {
      retVal["dataSources"] = TSOGUtils.toTSOGArray(this._dataSources, serializeContext);
    }
    if (this._focusedNodeId != null) {
      retVal["focusedNodeId"] = this._focusedNodeId;
    }
    if (this._messages != null) {
      retVal["messages"] = TSOGUtils.toTSOGArray(this._messages, serializeContext);
    }
    if (this._rootNode != null) {
      retVal["rootNode"] = TSOGUtils.toTSOGNativeObject(this._rootNode, serializeContext);
    }
    if (this._templateMap != null) {
      retVal["templateMap"] = this._templateMap;
    }
    return retVal;
  }
  get dataSources() {
    return this._dataSources;
  }
  set dataSources(value) {
    this._dataSources = value;
  }
  get focusedNodeId() {
    return this._focusedNodeId;
  }
  set focusedNodeId(value) {
    this._focusedNodeId = value;
  }
  get messages() {
    return this._messages;
  }
  set messages(value) {
    this._messages = value;
  }
  get rootNode() {
    return this._rootNode;
  }
  set rootNode(value) {
    this._rootNode = value;
  }
  get templateMap() {
    return this._templateMap;
  }
  set templateMap(value) {
    this._templateMap = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceBase.js.map
